import { jsx as _jsx } from "react/jsx-runtime";
export const CodePenEmbed = ({ contentInfo }) => {
    return (_jsx("iframe", { allowFullScreen: true, loading: "lazy", src: `https://codepen.io/${contentInfo.username}/embed/${contentInfo.penId}?default-tab=html%2Cresult&theme-id=light`, style: {
            alignItems: 'center',
            border: 'none',
            borderRadius: 6,
            boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1)',
            boxSizing: 'border-box',
            display: 'flex',
            height: 400,
            justifyContent: 'center',
            width: '100%',
        } }));
};
//# sourceMappingURL=CodePenEmbed.js.map